import React from 'react';
import PropTypes from 'prop-types';
import GatsbyLink from 'gatsby-link';

import DLSLink from 'airbnb-dls-web/build/exp/Link';
import Labeled from 'airbnb-dls-web/build/exp/Labeled';
import { withStyles, css, withStylesPropTypes } from 'airbnb-dls-web/build/themes/withStyles';

// Using Gatsby's link component allows us to benefit from the Gatsby-specific
// improvements it makes over react-router's link. This component is a fusion of
// Gatsby Link and DLS styles. We also maintain the DLS prop API (meaning we use
// "href" over "to")

const propTypes = {
  ...withStylesPropTypes,
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  navigation: PropTypes.bool,
  footer: PropTypes.bool,
  beforeIcon: PropTypes.node,
  afterIcon: PropTypes.node,
  onPress: PropTypes.func,
};

const defaultProps = {
  href: null,
  navigation: false,
  footer: false,
  beforeIcon: null,
  afterIcon: null,
  onPress() {},
};

function Link(props) {
  const { children, href, styles, navigation, footer, beforeIcon, afterIcon, onPress } = props;

  // If the link is to an external link, use the regular DLS Link
  // component. GatsbyLink only works with internal links
  if (href.includes('http') || href.includes('https')) {
    return <DLSLink {...props}>{children}</DLSLink>;
  }

  let inner;

  if (beforeIcon) {
    inner = <Labeled before={beforeIcon}>{children}</Labeled>;
  } else if (afterIcon) {
    inner = <Labeled after={afterIcon}>{children}</Labeled>;
  } else {
    inner = children;
  }

  return (
    <GatsbyLink
      to={href}
      onClick={onPress}
      {...css(styles.component, navigation && styles.navigation, footer && styles.footer)}
    >
      {inner}
    </GatsbyLink>
  );
}

Link.propTypes = propTypes;
Link.defaultProps = defaultProps;

export default withStyles(({ font, color }) => ({
  component: {
    color: color.textLink,
    font: 'inherit',
    fontFamily: font.FONT_FAMILY,
    textDecoration: 'none',

    ':hover': {
      textDecoration: 'underline',
    },

    ':active': {
      color: color.textLinkActive,
    },
  },

  navigation: {
    color: color.textDark,
  },

  footer: {
    color: color.textMuted,
  },
}))(Link);



// WEBPACK FOOTER //
// ./src/components/Link.jsx